import { Injectable, Injector } from "@angular/core";
import { ProductsService } from "./products.service";
import { AboutService } from "./about.service";
import { AlertService } from "../views/alert/alert.service";
import { AppLanguageService } from "./appLanguage/app-language.service";
import { ProjectService } from "./project.service";
import { ProjcarouselService } from "./projcarousel.service";
@Injectable({
  providedIn: "root"
})
export class FacadeService {
  private _productsService: ProductsService;
  private _AboutService: AboutService;
  private _AlertService: AlertService;
  private _appLanguageService: AppLanguageService;
  private _ProjectService: ProjectService;
  private _ProjCarousel : ProjcarouselService;

  constructor(private _injector: Injector) {}

  get AppLanguage(): AppLanguageService {
    if (!this._appLanguageService) {
      this._appLanguageService = this._injector.get(AppLanguageService);
    }

    return this._appLanguageService;
  }

  get Product(): ProductsService {
    if (!this._productsService) {
      this._productsService = this._injector.get(ProductsService);
    }

    return this._productsService;
  }

  get About(): AboutService {
    if (!this._AboutService) {
      this._AboutService = this._injector.get(AboutService);
    }

    return this._AboutService;
  }
  get ProjectService() :ProjectService {
    if (!this._ProjectService){
      this._ProjectService = this._injector.get(ProjectService);
    }
    return this._ProjectService;
  }
  get ProjCarousel() :ProjcarouselService {
    if (!this.ProjCarousel){
      this._ProjCarousel = this._injector.get(ProjcarouselService);
    }
    return this.ProjCarousel;
  }

  get Alert(): AlertService {
    if (!this._AlertService) {
      this._AlertService = this._injector.get(AlertService);
    }
    return this._AlertService;
  }
}
